import { Stack, styled, Typography } from '@mui/material';

export const MetadataContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(5),
  background: theme.palette.grey[700],
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

export const BasicMetadataContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
}));

export const MetadataTitle = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 700,
  lineHeight: theme.spacing(3),
}));
